const reducers = {
  setSecure: (state, action) => {
    state.secure = action.payload
  },
  setLoading: (state, action) => {
    state.loading = action.payload
  },
  setAddress: (state, action) => {
    state.address = action.payload
  },
  setAddressActive: (state, action) => {
    state.addressActive = action.payload
    state.newAddress = { ...state.address };
  },
  setCartId: (state, action) => {
    state.cartId = action.payload
  },
}

export default reducers

